import React from 'react';
import styled from 'styled-components';

import { ThemeToggler } from 'gatsby-plugin-dark-mode';

const Switch = styled.button`
  --size: 2.5rem;
  cursor: pointer;

  display: flex;
  position: relative;
  padding: 0;
  height: calc(2 * var(--size));
  width: min-content;
  flex-direction: column;

  border-radius: var(--border-radius);
  justify-content: space-between;

  background: rgba(255, 255, 255, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.25);

  font-size: calc(var(--size) / 2);
  backdrop-filter: blur(6.5px);
  border: var(--glass-border);

  box-shadow: 0 0 16px 0 rgba(255, 255, 255, 0.2);
  transition: box-shadow 250ms ease-in;

  :hover {
    box-shadow: 0 0 32px 0 rgba(255, 255, 255, 0.33);
  }

  @media (min-width: 540px) {
    width: calc(2 * var(--size));
    height: min-content;
    flex-direction: row;
  }
`;

const StyledEmoji = styled.span`
    z-index: 1;
    width: var(--size);
    height: var(--size);

    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--border-radius);

    background: rgba(255, 255, 255, 0);
    transition: background 250ms ease-in, opacity 250ms ease-in;

    opacity: ${({ isActive }) => (!isActive ? 0.33 : 1)};

    :hover {
      background: rgba(255, 255, 255, 0.5);
      opacity: 1;
    }
`;

export default function ThemeToggle({ className }) {
  return (
    <ThemeToggler>
      {({ toggleTheme, theme }) => {
        const isDarkMode = theme === 'dark';
        if (theme === null) return null;

        return (
          <Switch
            className={className}
            type="button"
            aria-label="theme-toggle"
            isActive={isDarkMode}
            // onClick={() => toggleTheme(isDarkMode ? 'light' : 'dark')}
          >
            <StyledEmoji
              isActive={!isDarkMode}
              role="img"
              aria-label="light-theme"
              onClick={() => toggleTheme('light')}
            >
              😎
            </StyledEmoji>

            <StyledEmoji
              isActive={isDarkMode}
              role="img"
              aria-label="dark-theme"
              onClick={() => toggleTheme('dark')}
            >
              🌒
            </StyledEmoji>
          </Switch>
        );
      }}
    </ThemeToggler>
  );
}
